import * as styles from './TagProgress.module.css'

function TagProgress() {
  return (
    <div className={styles.bar}>
      <div className={styles.fill} />
    </div>
  )
}

export default TagProgress
